import React, { Component } from 'react';
import PropTypes from 'prop-types';
import SwitchRow from '../../common/forms/SwitchRow';

export default class VerifiedCheckIn extends Component {
  render () {
    const { company, onChange, isChecked } = this.props;

    if (!company || !company.checkin_verification_allowed) {
      return false;
    }

    return (
      <section className='job-posting-section'>
        <h4 className='mb-3'>Use Verified Check-in</h4>

        <SwitchRow
          checked={isChecked}
          label='Enforce workers to scan QR-code'
          onChange={onChange}
        />
      </section>
    );
  }
}

VerifiedCheckIn.propTypes = {
  isChecked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  company: PropTypes.object
};



// WEBPACK FOOTER //
// ./src/components/app/createJob/VerifiedCheckIn.js